import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import {
    BELOW_THE_HEADER,
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
    INSIDE_THE_HEADER,
    BASE_URL_APIv5,
} from 'constants/ActionTypes';
import SearchBox from 'components/SearchBox';
import MailNotification from '../MailNotification/index';
import AppNotification from '../AppNotification/index';
import AppNotificationDoc from '../AppNotificationDoc/index';
import AppNotificationLock from '../AppNotificationLock/index';
import CardHeader from 'components/dashboard/Common/CardHeader/index';
import { switchLanguage, toggleCollapsedNav } from 'actions/Setting';
import IntlMessages from 'util/IntlMessages';
import LanguageSwitcher from 'components/LanguageSwitcher/index';
import Menu from 'components/TopNav/Menu';
import UserInfoPopup from 'components/UserInfo/UserInfoPopup';
import axios from 'axios';
import moment from "moment"
import {
    reqDataNotif,
    reqDataNotifLock,
    reqDataNotifDocs,
} from 'actions/Notif'

const token = localStorage.getItem('apiKey')
const rolename = localStorage.getItem('rolename')
const companyIdGlobal = localStorage.getItem('companyId')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}

class Header extends React.Component {

    constructor() {
        super();
        this.state = {
            anchorEl: undefined,
            searchBox: false,
            searchText: '',
            mailNotification: false,
            userInfo: false,
            langSwitcher: false,
            appNotification: false,
            notifData: [],
            notifDataDocs: [],
            dataNotif: [],
            dataNotifDocs: [],
            top5: false,
            packageName: '',
            dataNotifLock: [],
            lockNotification: false
        }
    }

    handleGetPackageName = async () => {
        const url = `${BASE_URL_APIv5}/master-role/search`,
            data =
            {
                paging: { "start": 0, "length": -1 },
                columns: [
                    { name: "role_name", logic_operator: "=", value: rolename, operator: "AND" }
                ]
            },
            obj = JSON.stringify(data),
            result = await axios.post(url, obj, config).then(res => res).catch(err => err.response)
        // console.log('get-package-name')
        // console.log(result)
        if (result.data.status === true) {
            this.setState({ packageName: result.data.data[0].package_name })
        } else {
            NotificationManager.error(result.data.message, 'Error message')
        }
    }

    handleGetDataNotif = async () => {
        let dataConfig = {
            paging: { start: 0, length: 10 }
        }
        const obj = JSON.stringify(dataConfig)
        const url = `${BASE_URL_APIv5}/log-notification/search`
        const result = await axios.post(url, obj, config).then(res => res).catch(err => err.response)
        // console.log('data-notif')
        if (result.data.status === true) {
            this.setState({ notifData: result.data.data })
        } else {
            NotificationManager.error(result.data.message, 'Error message')
        }

    }

    handleGetDataNotifDoc = async () => {
        // console.log("masuk handleGetDataNotifDoc")
        let payload = {
            "start": 0,
            "length": 5,
            "notifType": "all",
            "companyId": companyIdGlobal,
            "notifName": "",
            "name": ""
        }

        let obj = JSON.stringify(payload)
        const result = await axios.post(`${BASE_URL_APIv5}/alert-notification-docs/search`, obj, config)
            .then((res) => res)
            .catch((error) => error.response)
        if (result.data.status === true) {
            // console.log("notifDataDocs:", result.data.data)
            this.setState({ notifDataDocs: result.data.data })
        } else {
            NotificationManager.error(result.data.message, 'Error message')
        }
    }

    componentDidMount() {
        this.handleGetDataNotif()
        this.handleGetDataNotifDoc()
        this.handleGetPackageName()
        this.props.reqDataNotif('event')
        this.props.reqDataNotifDocs('event')
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data_notif !== prevState.dataNotif) {
            return {
                dataNotif: nextProps.data_notif
            }
        }

        if (nextProps.data_notif_docs !== prevState.dataNotifDocs) {
            return {
                dataNotifDocs: nextProps.data_notif_docs
            }
        }

        return null
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.notifData !== prevState.notifData) {
            const element = document.getElementById("notif-alert");
            // const element2 = document.getElementById("notif-doc");
            element.classList.add("icon-alert", "animated", "infinite", "wobble");
            // element2.classList.add("icon-alert", "animated", "infinite", "wobble");
        }

        if (this.state.dataNotif !== prevState.dataNotif) {
            let val = []
            const data1 = this.state.dataNotif
            const data2 = prevState.dataNotif

            if (data2.length !== 0) {
                data1.map(res => {
                    if (data2.includes(res) === false) {
                        val.push(res)
                        // console.log("checked")
                    }
                })
            } else {
                val = data1
            }

            // val.map(res => {
            //        const string = `[${res.licensePlate}] is ${res.description} at ${res.street}`
            //        NotificationManager.info(string, 'Notification message')
            // })
            // this.handleGetDataNotif()
        }

        if (this.state.notifDataDocs !== prevState.notifDataDocs) {
            const element = document.getElementById("notif-alert");
            // const element2 = document.getElementById("notif-doc");
            element.classList.add("icon-alert", "animated", "infinite", "wobble");
            // element2.classList.add("icon-alert", "animated", "infinite", "wobble");
        }

        if (this.state.dataNotifDocs !== prevState.dataNotifDocs) {
            let val = []
            const data1 = this.state.dataNotifDocs
            const data2 = prevState.dataNotifDocs

            if (data2.length !== 0) {
                data1.map(res => {
                    if (data2.includes(res) === false) {
                        val.push(res)
                        // console.log("checked")
                    }
                })
            } else {
                val = data1
            }

            // val.map(res => {
            //        const string = `[${res.licensePlate}] is ${res.description} at ${res.street}`
            //        NotificationManager.info(string, 'Notification message')
            // })
            // this.handleGetDataNotif()
        }
    }

    onAppNotificationSelect = () => {

        const element = document.getElementById("notif-alert");
        element.classList.remove("icon-alert", "animated", "infinite", "wobble");
        this.setState({
            appNotification: !this.state.appNotification
        })

    };
    onMailNotificationSelect = () => {
        const element = document.getElementById("notif-doc");
        element.classList.remove("icon-alert", "animated", "infinite", "wobble");
        this.setState({
            mailNotification: !this.state.mailNotification
        })
    };
    onLockNotificationSelect = () => {
        const element = document.getElementById("notif-doc");
        element.classList.remove("icon-alert", "animated", "infinite", "wobble");
        this.setState({
            lockNotification: !this.state.lockNotification
        })
    };
    onLangSwitcherSelect = (event) => {
        this.setState({
            langSwitcher: !this.state.langSwitcher, anchorEl: event.currentTarget
        })
    };
    onSearchBoxSelect = () => {
        this.setState({
            searchBox: !this.state.searchBox
        })
    };
    onAppTop5 = () => {
        this.setState({
            top5: true
        })
    };
    handleCloseModal = () => {
        this.setState({
            top5: false
        })
    }
    onUserInfoSelect = () => {
        this.setState({
            userInfo: !this.state.userInfo
        })
    };
    handleRequestClose = () => {
        this.setState({
            langSwitcher: false,
            userInfo: false,
            mailNotification: false,
            appNotification: false,
            searchBox: false
        });
    };


    onToggleCollapsedNav = (e) => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };

    updateSearchText(evt) {
        this.setState({
            searchText: evt.target.value,
        });
    }

    SwitchCase(companyId) {
        switch(companyId) {
          case '257':
            return 'You are a Admin.';
          case '77':
            return 'You are a Manager.';
          default:
            return 'You are a User';
        }
    }

    render() {
        const { drawerType, locale, navigationStyle, horizontalNavPosition } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'd-block d-xl-none' : drawerType.includes(COLLAPSED_DRAWER) ? 'd-block' : 'd-none';
        const headerClassName = localStorage.companyId != 286 ? `app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}` : `header-red ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`;
        return (
            <AppBar
                style={{ height: 60, }}
                className={
                    companyIdGlobal != 286 ?
                    `app-main-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}` :
                    `duta-trans-header ${(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) ? 'app-main-header-top' : ''}`
                    }>
                <Toolbar className="app-toolbar" disableGutters={false}>
                    {navigationStyle === HORIZONTAL_NAVIGATION ?
                        <div className="d-block d-md-none pointer mr-3" onClick={this.onToggleCollapsedNav}>
                            <span className="jr-menu-icon">
                                <span className="menu-icon" />
                            </span>
                        </div>
                        :
                        <IconButton className={`jr-menu-icon mr-3 ${drawerStyle}`} aria-label="Menu"
                            onClick={this.onToggleCollapsedNav}>
                            <span className="menu-icon" />
                        </IconButton>
                    }


                    <Link className="app-logo mr-2 d-none d-sm-block" to="/">
                        
                        {/* <img src={(() => {
                            switch (localStorage.companyId) {
                                case '257':
                                    return ("assets/images/logo-header/diptapermata-white.png")
                                case '77':
                                    return ("assets/images/logo-header/firstlogistics-white.png")
                                case '286':
                                    return ("assets/images/logo-header/dutatrans-white.png")
                                case '404':
                                    return ("assets/images/logo-header/finlogo.png")
                                case '554':
                                    return ("assets/images/logo-header/esway.png") 
                                case '728':
                                    return ("assets/images/logo-header/advotics_white.png") 
                                case '723':
                                    return ("assets/images/logo-header/gamatechno.png") 
                                default:
                                    return ([ this.state.packageName === 'Lite'
                                        ? "assets/images/logo-header/newosloglite.png" 
                                        : "assets/images/logo-header/newosloghitabeta.png"
                                    ]) 
                            }
                        })()} alt="oslog" title="oslog" /> */}

                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/newosloglite.png" : "assets/images/logo-header/newoslog.png"} alt="oslog" title="oslog" />*/}
                        {/*<img style={{ width: '250px', height: '50px', marginBottom: '20px' }} src={this.state.packageName === 'Lite' ? "assets/images/logo-header/newosloglite.png" : "assets/images/ciputra-text.png"} alt="oslog" title="oslog" />*/}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/pinslogo.png":"assets/images/logo-header/pinslogo2.png"} alt="oslog" title="oslog"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/sucofindo2.png":"assets/images/sucofindo2.png"} alt="sucofindo" title="sucofindo"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/Lintasarta.png":"assets/images/logo-header/Lintasarta.png"} width="80" height="130" alt="oslog" title="oslog"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/text-epoool.png":"assets/images/logo-header/logoepoool.png"} alt="oslog" title="oslog" height="50px" width="130px"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/geohr.png":"assets/images/geohr.png"} alt="oslog" title="oslog" height="50px" width="130px"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/blog.png":"assets/images/blog.png"} alt="oslog" title="oslog" height="50px" width="130px"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/newosloglite.png":"assets/images/logo-header/sistelindo.png"} alt="oslog" title="oslog"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/pancago.png":"assets/images/logo-header/pancago.png"} alt="oslog" title="oslog" height="80px" width="200px"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/finlogo.png":"assets/images/logo-header/finlogo.png"} alt="oslog" title="oslog" height="80px" width="200px"/> */}
                        {/*<img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/artlog.png":"assets/images/logo-header/artlog.png"} alt="artlog" title="artlog"/>*/}
                        {/*<img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/gmsi-logo.png":"assets/images/logo-header/gmsi-logo.png"} alt="artlog" title="PT. Global Mobility Service Indonesia"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/armytrack-white.png":"assets/images/logo-header/armytrack-white.png"} alt="army" title="ARMY"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/kitos_white.png":"assets/images/logo-header/kitos_white.png"} alt="kitos" title="KITOS"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/logo-header/quincus_white.png":"assets/images/logo-header/quincus_white.png"} alt="oslog" title="oslog" height="50px" width="130px"/> */}
                        {/* <img src={this.state.packageName === 'Lite' ? "assets/images/ntc_19_header.jpg":"assets/images/ntc_19_header.jpg"} alt="oslog" title="oslog" height="70px" width="300px"/> */}
                    </Link>


                    {/* <SearchBox styleName="d-none d-lg-block" placeholder=""
                               onChange={this.updateSearchText.bind(this)}
                               value={this.state.searchText}/>
                    {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === INSIDE_THE_HEADER) &&
                    <Menu/>} */}

                    <ul className="header-notifications list-inline ml-auto">
                        {/*<li className="d-inline-block d-lg-none list-inline-item">
                            <Dropdown
                                className="quick-menu nav-searchbox"
                                isOpen={this.state.searchBox}
                                toggle={this.onSearchBoxSelect.bind(this)}>

                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">
                                    <IconButton className="icon-btn size-30">
                                        <i className="zmdi zmdi-search zmdi-hc-fw"/>
                                    </IconButton>
                                </DropdownToggle>

                                <DropdownMenu right className="p-0">
                                    <SearchBox styleName="search-dropdown" placeholder=""
                                               onChange={this.updateSearchText.bind(this)}
                                               value={this.state.searchText}/>
                                </DropdownMenu>
                            </Dropdown>
                        </li>*/}
                        {/* <li className="list-inline-item app-tour">

                            <Dropdown
                                className={
                                    companyIdGlobal != 286 ?
                                    "quick-menu" : "quick-menu-duta-trans"
                                }
                                isOpen={false}
                                toggle={this.onAppTop5.bind(this)}
                            >

                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">
                                    <IconButton className="icon-btn size-30">
                                        <i className="zmdi zmdi-view-web"/>
                                    </IconButton>
                                </DropdownToggle>
                            </Dropdown>
                        </li> */}

                        <Dialog open={this.state.top5} onClose={this.handleCloseModal} fullWidth maxWidth={'md'}>
                            <DialogTitle>Top 5 Page Visited</DialogTitle>

                            <DialogContent>
                                <Divider />
                                <div className="container-page">
                                    <div>
                                        <h3>Tracking Monitoring</h3>
                                        <p><i class="zmdi zmdi-desktop-windows zmdi-hc-5x"></i></p>
                                        <p><i className="zmdi zmdi-view-web" /> &nbsp;1468</p>
                                    </div>
                                    <div>
                                        <h3>Sales Order</h3>
                                        <p><i class="zmdi zmdi-assignment-account zmdi-hc-5x"></i></p>
                                        <p><i className="zmdi zmdi-view-web" /> &nbsp;1228</p>
                                    </div>
                                    <div>
                                        <h3>Order Assignment</h3>
                                        <p><i class="zmdi zmdi-assignment zmdi-hc-5x"></i></p>
                                        <p><i className="zmdi zmdi-view-web" /> &nbsp;1108</p>
                                    </div>
                                    <div>
                                        <h3>Monitoring Dispatch</h3>
                                        <p><i class="zmdi zmdi-desktop-windows zmdi-hc-5x"></i></p>
                                        <p><i className="zmdi zmdi-view-web" /> &nbsp;1098</p>
                                    </div>
                                    <div>
                                        <h3>Dashboard Order Mangement</h3>
                                        <p><i class="zmdi zmdi-view-dashboard zmdi-hc-5x"></i></p>
                                        <p><i className="zmdi zmdi-view-web" /> &nbsp;1006</p>
                                    </div>
                                </div>

                            </DialogContent>
                            <DialogActions>
                                {/* <Button  color="secondary">
                                    <IntlMessages id="userManage.cancel"/>
                                </Button> */}
                                <Button onClick={this.handleCloseModal} color="primary">
                                    close
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* <li className="list-inline-item">
                            <Dropdown
                                className={
                                    companyIdGlobal != 286 ?
                                    "quick-menu" : "quick-menu-duta-trans"
                                }
                                isOpen={this.state.langSwitcher}
                                toggle={this.onLangSwitcherSelect.bind(this)}>

                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">
                                    <div className="d-flex align-items-center pointer pt-1">
                                        <i className={`flag flag-24 flag-${locale.icon}`}/>
                                    </div>
                                </DropdownToggle>

                                <DropdownMenu right className="w-50">
                                    <LanguageSwitcher switchLanguage={this.props.switchLanguage}
                                                      handleRequestClose={this.handleRequestClose}/>
                                </DropdownMenu>
                            </Dropdown>


                        </li> */}
                        <li className="list-inline-item app-tour">
                            <Dropdown
                                className={
                                    companyIdGlobal != 286 ?
                                    "quick-menu" : "quick-menu-duta-trans"
                                }
                                isOpen={this.state.appNotification}
                                toggle={this.onAppNotificationSelect.bind(this)}>

                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">
                                    <IconButton className="icon-btn size-20 font-size-20">
                                        {/*javaz*/}
                                        <i id="notif-alert" className="zmdi zmdi-notifications-active icon-alert animated infinite wobble" />
                                        {/*b-log*/}
                                        {/*<i id="notif-alert" className="zmdi zmdi-notifications-active icon-alert animated infinite wobble text-primary"/>*/}
                                    </IconButton>
                                </DropdownToggle>

                                <DropdownMenu right>
                                    <CardHeader styleName="align-items-center"
                                        onAppNotificationSelect={this.onAppNotificationSelect.bind(this)}
                                        heading={<IntlMessages id="appNotification.title" />} />
                                    <AppNotification dataNotif={this.state.dataNotif} />
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        <li className="list-inline-item mail-tour">
                            <Dropdown
                                className={
                                    companyIdGlobal != 286 ?
                                    "quick-menu" : "quick-menu-duta-trans"
                                }
                                isOpen={this.state.mailNotification}
                                toggle={this.onMailNotificationSelect.bind(this)}
                            >
                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">

                                    <IconButton className="icon-btn size-20 font-size-20">
                                        {/*javaz*/}
                                        <i id="notif-doc" className="zmdi zmdi-comment-alt-text icon-alert animated infinite wobble zmdi-hc-fw" />
                                        {/*b-log*/}
                                        {/*<i id="notif-doc" className="zmdi zmdi-comment-alt-text icon-alert animated infinite wobble zmdi-hc-fw text-primary"/>*/}
                                    </IconButton>
                                </DropdownToggle>


                                <DropdownMenu right>
                                    <CardHeader styleName="align-items-center"
                                        onMailNotificationSelect={this.onMailNotificationSelect.bind(this)}
                                        heading={<IntlMessages id="mailNotification.title" />} />
                                    <AppNotificationDoc dataNotifDocs={this.state.dataNotifDocs} />
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        {/* <li className="list-inline-item key-tour">
                            <Dropdown
                                className={
                                    companyIdGlobal != 286 ?
                                    "quick-menu" : "quick-menu-duta-trans"
                                }
                                isOpen={this.state.lockNotification}
                                toggle={this.onLockNotificationSelect.bind(this)}
                            >
                                <DropdownToggle
                                    className="d-inline-block"
                                    tag="span"
                                    data-toggle="dropdown">

                                    <IconButton className="icon-btn size-20 font-size-20">
                                        <i id="notif-doc" className="zmdi zmdi-key icon-alert zmdi-hc-fw"/>
                                    </IconButton>
                                </DropdownToggle>


                                <DropdownMenu right>
                                    <CardHeader styleName="align-items-center"
                                                heading="Seal Notification"/>
                                    <AppNotificationDoc dataNotif={this.state.notifDataLock}/>
                                </DropdownMenu>
                            </Dropdown>
                        </li> */}

                        {navigationStyle === HORIZONTAL_NAVIGATION &&
                            <li className="list-inline-item user-nav">
                                <Dropdown
                                    className={
                                    companyIdGlobal != 286 ?
                                    "quick-menu" : "quick-menu-duta-trans"
                                }
                                    isOpen={this.state.userInfo}
                                    toggle={this.onUserInfoSelect.bind(this)}>

                                    <DropdownToggle
                                        className="d-inline-block"
                                        tag="span"
                                        data-toggle="dropdown">
                                        <IconButton className="icon-btn size-30">
                                            <Avatar
                                                alt='...'
                                                src='https://via.placeholder.com/150x150'
                                                className="size-30"
                                            />
                                        </IconButton>
                                    </DropdownToggle>

                                    <DropdownMenu right>
                                        <UserInfoPopup />
                                    </DropdownMenu>
                                </Dropdown>
                            </li>}
                    </ul>
                </Toolbar>
            </AppBar>
        );
    }

}

const mapStateToProps = ({ settings, notif }) => {
    const { drawerType, locale, navigationStyle, horizontalNavPosition } = settings;
    const { data_notif, data_notif_lock, data_notif_docs } = notif;
    return { drawerType, locale, navigationStyle, horizontalNavPosition, data_notif, data_notif_lock, data_notif_docs }
};

export default withRouter(connect(mapStateToProps, {
    toggleCollapsedNav,
    switchLanguage,
    reqDataNotif,
    reqDataNotifDocs,
    reqDataNotifLock,
})(Header));


// WEBPACK FOOTER //
// ./components/Header/index.js